module.exports = "<app-master-menu></app-master-menu>\n<div class=\"clearfix\"></div>\n<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/unicore-masters/unicore-masters.component.html
// module id = ./src/app/unicore-masters/unicore-masters.component.html
// module chunks = main